import React, { useState } from 'react'
import { Dialog, Divider, Grid, Typography, Tooltip, IconButton, makeStyles } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'

import { useLiterals } from '~/components/Literals'
import useViewportSizes from '~/components/useViewportSize'
import AppBar from '../PositionDialog/AppBar'

import imageNotFound from '~/assets/imageNotFound.svg'

const useStyles = makeStyles({
  image: {
    width: '100%',
    height: 150,
    objectFit: 'cover',
    border: '2px solid #F2F2F2',
    borderRadius: 4,
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
  },
  zoomImage: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    width: '100vw',
    height: '100vh',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, .6)',
  },
  backDropImage: {
    position: 'fixed',
    width: '100vw',
    height: '100vh',
  },
})

function ZoomImageClicked({ images, clickedImage, setClickedImage, isMobile }) {
  const classes = useStyles()
  const { getLiteral } = useLiterals()

  const [filtered] = images.filter(({ name }) => name === clickedImage)

  const handleClose = () => setClickedImage(null)

  if (!filtered) return null

  return (
    <Grid className={classes.zoomImage} onClick={handleClose}>
      <Grid style={{ width: isMobile ? 300 : 500, display: 'flex', justifyContent: 'flex-end' }}>
        <Tooltip title={getLiteral('1251')} placement="left">
          <IconButton aria-label={getLiteral('1251')} size="small" onClick={handleClose}>
            <CloseIcon style={{ color: '#FFF' }} />
          </IconButton>
        </Tooltip>
      </Grid>
      <img
        src={filtered.googleUrl}
        className={classes.image}
        style={{ height: isMobile ? 300 : 500, width: isMobile ? 300 : 500 }}
      />
    </Grid>
  )
}

export function StoreDialogImages({ isOpen, setIsOpen, store, images }) {
  const theme = useTheme()
  const viewport = useViewportSizes()
  const classes = useStyles()
  const { getLiteral } = useLiterals()

  const [clickedImage, setClickedImage] = useState('')
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const handleClose = () => setIsOpen(false)

  return (
    <Dialog fullWidth fullScreen={isMobile} maxWidth="sm" onClose={handleClose} open={isOpen}>
      {isMobile && <AppBar title={store?.name} titleAlign="left" onClose={handleClose} />}
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 16,
        }}
      >
        <Typography style={{ fontWeight: 500 }}>Fotos da loja</Typography>
        {!isMobile && (
          <Tooltip title={getLiteral('1251')} placement="bottom">
            <IconButton aria-label={getLiteral('1251')} size="small" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      <Divider style={{ width: '100%' }} />

      <Grid style={{ padding: 16, maxHeight: isMobile ? '100%' : 600, overflowY: 'auto' }}>
        <Grid
          style={{
            gap: 8,
            display: 'grid',
            placeItems: 'center',
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          }}
        >
          {images.map((image, index) => (
            <img
              key={index}
              src={image.googleUrl}
              loading="lazy"
              className={classes.image}
              onClick={() => setClickedImage(image.name)}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null // prevents looping
                currentTarget.src = imageNotFound
                currentTarget.style.objectFit = 'contain'
              }}
            />
          ))}
        </Grid>

        <ZoomImageClicked
          images={images}
          clickedImage={clickedImage}
          setClickedImage={setClickedImage}
          isMobile={isMobile}
        />
      </Grid>
    </Dialog>
  )
}
